import { PostgrestClient } from "@supabase/postgrest-js";
import { VipTagConfig } from "../types";

export class VipTagConfigService {
  private postgrest: PostgrestClient;

  constructor(postgrest: PostgrestClient) {
    this.postgrest = postgrest;
  }

  async getVipTags(fboId: string): Promise<VipTagConfig[]> {
    const { data, error } = await this.postgrest
      .from("vip_tag_config")
      .select("*")
      .eq("fbo_id", fboId)
      .order("display_order");

    if (error) {
      console.error("Failed to fetch VIP tag config:", error);
      throw error;
    }

    return data || [];
  }

  async createVipTag(
    fboId: string,
    tag: {
      tag_code: string;
      tag_label: string;
      tag_color: string;
      display_order: number;
    }
  ): Promise<VipTagConfig> {
    const { data, error } = await this.postgrest
      .from("vip_tag_config")
      .insert({
        fbo_id: fboId,
        tag_code: tag.tag_code,
        tag_label: tag.tag_label,
        tag_color: tag.tag_color,
        display_order: tag.display_order,
      })
      .select()
      .single();

    if (error) {
      console.error("Failed to create VIP tag:", error);
      throw error;
    }

    return data;
  }

  async updateVipTag(
    tagId: string,
    updates: Partial<{
      tag_code: string;
      tag_label: string;
      tag_color: string;
      display_order: number;
    }>
  ): Promise<VipTagConfig> {
    const { data, error } = await this.postgrest
      .from("vip_tag_config")
      .update(updates)
      .eq("id", tagId)
      .select()
      .single();

    if (error) {
      console.error("Failed to update VIP tag:", error);
      throw error;
    }

    return data;
  }

  async deleteVipTag(tagId: string): Promise<void> {
    const { error } = await this.postgrest
      .from("vip_tag_config")
      .delete()
      .eq("id", tagId);

    if (error) {
      console.error("Failed to delete VIP tag:", error);
      throw error;
    }
  }

  async reorderVipTags(
    fboId: string,
    orderedTagIds: string[]
  ): Promise<void> {
    // Update display_order for each tag
    for (let i = 0; i < orderedTagIds.length; i++) {
      const { error } = await this.postgrest
        .from("vip_tag_config")
        .update({ display_order: i + 1 })
        .eq("id", orderedTagIds[i])
        .eq("fbo_id", fboId);

      if (error) {
        console.error("Failed to reorder VIP tags:", error);
        throw error;
      }
    }
  }
}
